import { render } from "./EducationSection.vue?vue&type=template&id=303c0ef3"
import script from "./EducationSection.vue?vue&type=script&lang=js"
export * from "./EducationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__